/** @format */

import Global from './container';

// This is only for wordpress
Global();
